import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraExposureOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 8a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1" />
    <path d="M16 24a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1" />
    <path d="M29 15h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2" />
    <path d="M8 16a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1" />
    <path d="M23.07 21.66a1 1 0 0 0-1.41 1.41l2.83 2.83a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41z" />
    <path d="M8.93 10.34a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41L7.51 6.1A1 1 0 0 0 6.1 7.51z" />
    <path d="M8.93 21.66 6.1 24.49a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l2.83-2.83a1 1 0 0 0-1.41-1.41" />
    <path d="M22.36 10.64a1 1 0 0 0 .71-.3l2.83-2.83a1 1 0 1 0-1.41-1.41l-2.83 2.83a1 1 0 0 0 0 1.41 1 1 0 0 0 .7.3" />
    <path d="M16 10a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 10v-8a4 4 0 1 1 0 8" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraExposureOutlineSVG);
ForwardRef.displayName = "IconCameraExposureOutline";
export { ForwardRef as IconCameraExposureOutline };
